import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import facebookIcon from "../../assets/images/social-media/facebook-icon.svg";
import twitterIcon from "../../assets/images/social-media/x-icon.svg";
import instagramIcon from "../../assets/images/social-media/instagrama-icon.svg";

const Footer = () => {
  return (
    <div className="footer-ui">
      <Container>
        <Row>
          <Col className="col-12 position-relative d-flex flex-row justify-content-between footer-content">
            <div className="about-content">
              <h4>CONCEPTA DIAGNOSTICS: A BOOTS UK COMPANY</h4>
            </div>
              <div className="right-footer-icons">
                <a href="https://www.instagram.com/bootsuk/" target="_blank" rel="noreferrer">
                  {" "}
                  <Image src={instagramIcon} />
                </a>
                <a href="https://www.facebook.com/BootsUK/" target="_blank" rel="noreferrer">
                  <Image src={facebookIcon} />
                </a>
                <a href="https://x.com/BootsUK" target="_blank" rel="noreferrer">
                  <Image src={twitterIcon} />
                </a>
              </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
